export default "__VITE_ASSET__CGud7RIl__"